var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.exportarPlanilha(_vm.itemContratoId)}}},[_c('span',{staticClass:"icon-button",attrs:{"title":"Requisições ao item"}},[_c('i',{staticClass:"fa fa-download"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }